export default __webpack_public_path__ + "static/media/Stripes_OffersIcon.891e24c1.svg";